// ABOUTME: A design-system icon used as a job action (list rows, detail headers, schedules), with its
// ABOUTME: tooltip: a plain clickable icon (no button, so no ripple) that still works from the keyboard.

import { Box, Tooltip } from '@ds/coolshop';
import { KeyboardEvent, MouseEvent, ReactNode } from 'react';

interface IActionIconProps {
    label: string;
    icon: ReactNode;
    disabled?: boolean;
    onClick: () => void;
}

export function ActionIcon(props: Readonly<IActionIconProps>) {
    const { label, icon, disabled, onClick } = props;

    // The icons sit in clickable rows: their events never reach the row, disabled or not.
    const handleClick = (event: MouseEvent) => {
        event.stopPropagation();
        if (!disabled) onClick();
    };

    const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopPropagation();
            if (!disabled) onClick();
        }
    };

    return (
        <Tooltip title={label}>
            <Box
                role="button"
                aria-label={label}
                aria-disabled={disabled}
                tabIndex={disabled ? -1 : 0}
                display="flex"
                alignItems="center"
                justifyContent="center"
                p={0.5}
                color={disabled ? 'action.disabled' : 'primary.main'}
                cursor={disabled ? 'default' : 'pointer'}
                onClick={handleClick}
                onKeyDown={handleKeyDown}
            >
                {icon}
            </Box>
        </Tooltip>
    );
}
